import axios from "@/api/config";

const baseURI = '/llm';
export default {
    getLLMData(type,content) {
        return new Promise((resolve, reject) => {
            resolve(
                axios({
                    url:  '/llm/analysis',
                    method: 'POST',
                    loading: true,
                    data:{content: content,type:type},
                    target:'article-view'
                })
            )
            reject()
        })
    },

    generateRedisToken({name, phone, wechat}) {
        return new Promise((resolve, reject) => {
            resolve(
                axios({
                    url:  '/redis/generate',
                    method: 'POST',
                    loading: true,
                    data:{name:name,phone:phone,wechat:wechat},
                    target:'article-view'
                })
            )
            reject()
        })
    },
    findRedisToken(tokenList) {
        return new Promise((resolve, reject) => {
            resolve(
                axios({
                    url:  '/redis/find',
                    method: 'POST',
                    loading: true,
                    data:{value:tokenList},
                    target:'article-view'
                })
            )
            reject()
        })
    },
    pushData(data) {
        return new Promise((resolve, reject) => {
            resolve(
                axios({
                    url:  '/redis/push',
                    method: 'POST',
                    loading: true,
                    data:data,
                    target:'article-view'
                })
            )
            reject()
        })
    },
    pullData(token) {
        return new Promise((resolve, reject) => {
            resolve(
                axios({
                    url:  '/redis/pull',
                    method: 'POST',
                    loading: true,
                    data:{value:token},
                    target:'article-view'
                })
            )
            reject()
        })
    },
}
